"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlFlowStorage = void 0;
var ControlFlowStorage;
(function (ControlFlowStorage) {
    ControlFlowStorage["FunctionControlFlowStorage"] = "function-control-flow-storage";
    ControlFlowStorage["StringControlFlowStorage"] = "string-control-flow-storage";
})(ControlFlowStorage || (exports.ControlFlowStorage = ControlFlowStorage = {}));
